import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { ServicesMarquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { Manifesto } from "../components/Manifesto";
import { Gallery } from "../components/Gallery";
import { BeforeAfter } from "../components/BeforeAfter";
import { QuoteForm } from "../components/QuoteForm";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-obsidian font-body text-white">
      <Header />
      <main>
        <Hero />
        <ServicesMarquee />
        <Services />
        <Manifesto />
        <Gallery />
        <BeforeAfter />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
